import { apiClient } from './apiClient';

export interface RevenueSummary {
  booked_30d: string;
  collected_30d: string;
  mrr: string;
  recurring_count: number;
  one_time_count: number;
  revenue_by_source: { source: string; revenue: string }[];
  booked_by_source: { source: string; revenue: string }[];
  revenue_by_contract_type_collected?: { recurring: string; one_time: string };
  revenue_by_contract_type_booked?: { recurring: string; one_time: string };
  upsell_pipeline_value?: string;
  upsell_closed_30d?: string;
  upsell_conversion_rate?: string;
  upsell_by_stage?: { stage: string; value: string }[];
}

export interface ContractCreatePayload {
  lead_id: string;
  contract_type: 'one_time' | 'recurring';
  total_value: string;
  recurring_amount?: string | null;
  recurring_interval?: 'monthly' | 'quarterly' | 'yearly' | null;
  start_date: string;
  end_date?: string | null;
}

export const revenueService = {
  async getSummary(): Promise<RevenueSummary> {
    return apiClient.get('/revenue/summary/');
  },

  async createContract(payload: ContractCreatePayload): Promise<{ id: string }> {
    return apiClient.post('/revenue/contracts/', payload);
  },
};
